
const navBreakPoint = 1025; // match from liquid variable pls

export const clickOrHoverToOpenMegaNav = (navType: 'click' | 'hover'): void => {
  const SELECTOR_LEVEL_1 = '[data-nav-toggle]'
  const SELECTOR_LEVEL_2 = '[data-nav-second-level]'
  
  const navToggles = document.querySelectorAll(SELECTOR_LEVEL_1) as NodeListOf<HTMLElement>;
  if (navToggles.length <= 0) return;

  const CLASS_TO_TOGGLE_LEVEL_1 = 'menu-open';
  const CLASS_TO_TOGGLE_LEVEL_2 = 'menu-open-level-2';

  const closeAllMeganavs = () => {
    document.querySelectorAll('.' + CLASS_TO_TOGGLE_LEVEL_1).forEach(t => t.classList.remove(CLASS_TO_TOGGLE_LEVEL_1));
  }

  const closeAllMininavs = () => {
    document.querySelectorAll(SELECTOR_LEVEL_2).forEach(t => t.classList.remove(CLASS_TO_TOGGLE_LEVEL_2));
    const level2 = document.querySelector('.manual-height') as HTMLElement ;
    if (level2 !== null) {
      level2.classList.remove('manual-height'); 
      level2.style.height = null;

    }

  /*  if (document.querySelector('.manual-height')){
      const level2 = document.querySelector('.' + CLASS_TO_TOGGLE_LEVEL_2).closest('.nav-second-level') as HTMLElement ;
      level2.style.height = null;
      level2.classList.remove('manual-height');
    } */
  }

  const openNav2 = (navItem: HTMLElement) : void => {
    closeAllMininavs()
    navItem.classList.add(CLASS_TO_TOGGLE_LEVEL_2)
    const level2 = document.querySelector('.' + CLASS_TO_TOGGLE_LEVEL_2).closest('.nav-second-level') as HTMLElement ;
    const level3 = document.querySelector('.' + CLASS_TO_TOGGLE_LEVEL_2 + ' .nav-third-level-links') as HTMLElement ;
    const nadverts = document.querySelector('.' + CLASS_TO_TOGGLE_LEVEL_2 + ' .nav-adverts') as HTMLElement ;
    let level3count = level3.childElementCount;
    let level3height = level3count *= 36;
    if (nadverts !== null && level3.childElementCount === 1) {
      level3height += nadverts.offsetHeight ;
    }
    if (level3height > level2.offsetHeight )
    { level2.style.minHeight = level3height + 'px';
      level2.classList.add('manual-height');
    }
  }

  const openNav1 = (navItem: HTMLElement) : void => {
    closeAllMeganavs()
    navItem.classList.add(CLASS_TO_TOGGLE_LEVEL_1)
    document.querySelector('body').classList.add('modal-visible')
    document.querySelector('body').classList.add('modal-menu')
    if(!document.querySelector('.' + CLASS_TO_TOGGLE_LEVEL_2) && window.innerWidth >= navBreakPoint) {
      openNav2(document.querySelector(SELECTOR_LEVEL_2))
    }
  }
  
  let timer: ReturnType<typeof setTimeout>;
  let timer2: ReturnType<typeof setTimeout>;
  const closeNav1 = (navItem: HTMLElement): void => {
    navItem.classList.remove(CLASS_TO_TOGGLE_LEVEL_1)
    document.querySelector('body').classList.remove('modal-visible')
    document.querySelector('body').classList.remove('modal-menu')
  } 

  navToggles.forEach(navToggle => {
    const target = document.querySelector(`[data-nav-target="${navToggle.dataset.navToggle}"]`) as HTMLElement
    
    //clicky type always on mobile
    navToggle.addEventListener('click', e => {
      if (!target) return
      if (window.innerWidth >= navBreakPoint && navType === 'hover') return //if on desktop nav and hover type
      e.preventDefault()
      if(navToggle.hasAttribute('data-nav-second-level')) {
        openNav2(target)
      } else {
        openNav1(target)
      }
    });
    
    //if hover type
    if (navType === 'hover') {
      navToggle.addEventListener('mouseenter', () => {
        clearTimeout(timer)
        clearTimeout(timer2)
        if (window.innerWidth < navBreakPoint) return
        if(navToggle.hasAttribute('data-nav-second-level')) {
          timer2 = setTimeout(() => {
            openNav2(target)
          }, 333);
        } else {
          timer = setTimeout(() => {
            openNav1(target)
          }, 333);
        }
      })
      target.addEventListener('mouseenter', () => {
        if (window.innerWidth < navBreakPoint) return
        clearTimeout(timer)
      })
      target.addEventListener('mouseleave', () => {
        if (window.innerWidth < navBreakPoint) return
        clearTimeout(timer)
        clearTimeout(timer2)
        timer = setTimeout(() => {
          if(!navToggle.hasAttribute('data-nav-second-level')) {
            closeNav1(target)
          }
        }, 333);
      })
    }

    //Always keyboard accesible
    navToggle.addEventListener('keyup', (event) => {
      if (event.key !== 'Enter') return
      if(navToggle.hasAttribute('data-nav-second-level')) {
        openNav2(target)
      } else {
        openNav1(target)
      }
    })
    target.addEventListener('keyup', (event) => {
      if (event.key !== 'Escape') return
      closeNav1(target)
      navToggle.focus()
    })
  });

  document.querySelector('[data-modal-underlay]').addEventListener('click', () => {
    // Closing all mega navs
    closeAllMeganavs()
  });

  document.querySelectorAll('[data-nav-btn-back]').forEach(btn =>
    btn.addEventListener('click', () => {
      // Closing all mega navs
      if(document.querySelector('.' + CLASS_TO_TOGGLE_LEVEL_2)) {
        closeAllMininavs()
      } else {
        closeAllMeganavs();
      }
    })
  );

  const closeBtn = document.querySelector('[data-nav-close]')
  if(closeBtn) {
    closeBtn.addEventListener('click', () => {
      closeAllMeganavs();
      closeAllMininavs();
    })
  }
}